import { ViewerPDFOverlayViewProviderService } from '@bukio/viewer';
import { Observable } from 'rxjs';

export type DrawingTool = 'pen' | 'eraser' | 'marquee' | 'text';

export interface DrawingPenOption {
  color: string;
  width: number;
  straight: boolean;
  fontFamily?: string;
}

export interface TextOption {
  color: string;
  fontSize: number;
  fontFamily: string;
}

export abstract class PDFDrawingService extends ViewerPDFOverlayViewProviderService {
  public abstract isDrawingMode: boolean;
  public abstract isDeviceSupportsStylus: boolean;

  public abstract readonly historyChange$: Observable<{
    canUndo: boolean;
    canRedo: boolean;
  }>;

  // 텍스트 객체 선택 이벤트 스트림 추가
  public abstract readonly textObjectSelected$?: Observable<{
    color: string;
    fontSize: number;
    fontFamily: string;
  } | null>;

  // 툴 변경 이벤트 스트림 추가
  public abstract readonly toolChanged$?: Observable<{
    tool: DrawingTool;
    option?: DrawingPenOption;
  }>;

  abstract loadDrawings(bid: string): Observable<void>;
  abstract saveDrawings(): Observable<void>;
  abstract clear(): void;
  abstract undo(): void;
  abstract redo(): void;
  abstract setTool(tool: DrawingTool, option?: DrawingPenOption): void;

  // 선택된 텍스트 객체의 색상 업데이트 메서드 추가
  abstract updateSelectedTextColor?(color: string): void;

  // 선택된 텍스트 객체의 폰트 크기 업데이트 메서드 추가
  abstract updateSelectedTextFontSize?(fontSize: number): void;

  // 선택된 텍스트 객체의 폰트 패밀리 업데이트 메서드 추가
  abstract updateSelectedTextFontFamily?(fontFamily: string): void;

  abstract getDrawnItemList(): Observable<string[]>;
  abstract getDrawingURL(iid: string): string | null;
}
